import React from "react";

const AIFirstContactCentreModernisation = () => {
  return (
    <div className="modal-content-body">
      <div className="modal-section">
        <div className="flex-content">
          <div>
            <h3>Use Case</h3>
          </div>
          <div>
            <p>
              Transform legacy or basic IVR into a conversational, AI-powered
              entry point—enabling natural language, faster intent resolution,
              cognitive routing, and seamless digital self-service.
            </p>
          </div>
        </div>

        <div className="flex-content">
          <div>
            <h3>Solution</h3>
          </div>
          <div>
            <a
              href="https://aws.amazon.com/marketplace/pp/prodview-q3lp7ipqr66pa?sr=0-2&ref_=beagle&applicationId=AWSMPContessa"
              target="_blank"
              rel="noopener noreferrer">
              Intelligent IVR Design
            </a>{" "}
            (Amazon Q, Lex, GenAI Orchestration)
          </div>
        </div>

        <div className="flex-content">
          <div>
            <h3>Target Segment</h3>
          </div>
          <div>
            <ul>
              <li>
                SMB/Enterprise with legacy IVR, complex call flows, or high
                customer frustration
              </li>
              <li>
                Organisations seeking higher containment, faster resolution, or
                a “GenAI” IVR refresh
              </li>
              <li>
                Head of CX/Contact Centre, IT Manager, Digital Transformation
                Lead, Ops Director, Product Owner
              </li>
            </ul>
          </div>
        </div>

        <div className="flex-content">
          <div>
            <h3>Target Personas</h3>
          </div>
          <div>
            <p>
              Head of CX/Contact Centre, IT Manager, Digital Transformation
              Lead, Ops Director, Product Owner
            </p>
          </div>
        </div>
      </div>

      {/* Opportunity & Qualification */}
      <div className="modal-section">
        <h2 className="modal-section-title">Opportunity and Qualification</h2>
        <div className="modal-section-grid">
          <div className="modal-column">
            <h3 className="modal-subtitle">
              What is the customer trying to accomplish?
            </h3>
            <ul>
              <li>
                Expedite customer intent capture with natural language and GenAI
              </li>
              <li>Reduce transfers, queue times, and agent workload</li>
              <li>Personalise and automate self-service workflows</li>
              <li>Integrate IVR with CRM and digital channels</li>
              <li>
                Unlock advanced analytics on call drivers and intent resolution
              </li>
            </ul>
          </div>

          <div className="modal-column">
            <h3 className="modal-subtitle">Key Words/ Questions</h3>
            <ul>
              <li>
                Frustration with current IVR (long menus, repeat transfers)
              </li>
              <li>Desire for natural language — “no more press 1 for…”</li>
              <li>Need for smarter routing and reduced queue times</li>
              <li>Wanting modern digital and voice self-service</li>
              <li>Facing high agent workload or hold times</li>
            </ul>
          </div>

          <div className="modal-column">
            <h3 className="modal-subtitle">Pain Point/ Challenge</h3>
            <ul>
              <li>High abandonment and call transfer rates</li>
              <li>Poor customer satisfaction with “press button” IVR</li>
              <li>Limited self-service and high manual workload</li>
              <li>
                Inability to promote digital channels or alternatives (SMS,
                chat)
              </li>
              <li>
                Lack of visibility on customer needs and real-time IVR analytics
              </li>
            </ul>
          </div>

          <div className="modal-column">
            <h3 className="modal-subtitle">Qualifying Questions</h3>
            <ul>
              <li>
                Are customers frequently dropped, transferred, or lost in your
                IVR?
              </li>
              <li>
                Do your agents spend significant time on simple, repeatable
                queries?
              </li>
              <li>
                Would modernising to conversational AI reduce operational cost
                and boost CX?
              </li>
              <li>
                Are you interested in using NLP, biometrics, or intent-based
                routing?
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Proposed Solution */}
      <div className="modal-section">
        <h2 className="modal-section-title">Proposed Solution / Value</h2>
        <div className="flex-content-half">
          <div>
            <h3>Solution Description</h3>
            <ul style={{marginTop: "10px"}}>
              <li>
                Bespoke IVR design: Using Amazon Lex, Amazon Q, and GenAI for
                natural conversations.
              </li>
              <li>
                Integration: Connects to CRM, knowledge base, customer
                authentication, and enables channel escalation.
              </li>
              <li>
                Queue alternative features: Includes virtual hold, SMS,
                callback, and digital promotion.
              </li>
              <li>
                Analytics and optimisation: Ongoing fine-tuning to continuously
                improve IVR performance.
              </li>
            </ul>
          </div>
          <div>
            <h3>Solution Benefits to AWS Customers</h3>
            <ul style={{marginTop: "10px"}}>
              <li>
                <strong>30%+ reduction</strong> in call transfers and average
                handle time
              </li>
              <li>
                <strong>Higher CX scores</strong> and improved customer
                convenience
              </li>
              <li>
                <strong>Scalable platform</strong> for AI-driven innovation—no
                “IVR rework” needed down the road
              </li>
              <li>
                <strong>Real-time insights</strong> for continuous CX
                improvement
              </li>
            </ul>
          </div>
        </div>

        <h2 className="modal-section-title" style={{marginTop: "30px"}}>
          Objection Handling
        </h2>
        <div className="flex-content-half">
          <div>
            <p>
              IVR Upgrades Are Complex: Delivered as a fully managed, turn-key
              service with minimal IT lift.
            </p>

            <p>
              Our Customers Won't Use Self-Service: Conversational AI raises
              containment and satisfaction, with seamless escalation.
            </p>

            <p>
              We're Not Ready for GenAI: Modular design - AI and GenAI features
              can be activated as the business is ready.
            </p>

            <p>
              Integration Seems Risky: Deep AWS and CRM integration expertise
              ensures robust, secure workflows.
            </p>

            <p>
              ROI Unclear: Results: 30% fewer transfers, faster intent capture,
              real-time analytics, and proven client wins.
            </p>
          </div>
        </div>
      </div>

      {/* FootNote */}
      <div className="modal-section" style={{border: 0}}>
        <div className="flex-content-half">
          <div className="flex-content-half">
            <div>
              <p>Resource Links</p>
            </div>
            <div>
              <p>Insert Link</p>
            </div>
          </div>
          <div className="flex-content-half">
            <div>
              <p>Average Opportunity ARR:</p>
            </div>
            <div>
              <p>
                Insert the expected Annualized AWS Consumption Revenue Value
              </p>
            </div>
          </div>
        </div>
        <div className="flex-content-half">
          <div className="flex-content-half">
            <div>
              <p>Case Study Links</p>
            </div>
            <div>
              <p>Insert Link</p>
            </div>
          </div>
          <div className="flex-content-half">
            <div>
              <p>Primary Partner Contact:</p>
            </div>
            <div>
              <p>
                Ryan Rayner, Co-Founder | ryan.rayner@icxeed.ai +61 438 286 198
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIFirstContactCentreModernisation;
